import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
interface UtmParams {
  [key: string]: string;
}
const snakeToCamelCase = (input: string): string => {
  return input.split('_').map((word, index) => index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)).join('');
};
export function useUtmParams() {
  const router = useRouter();
  const [utmParams, setUtmParams] = useState<UtmParams>({});
  useEffect(() => {
    if (!router.isReady) return;
    const query = router.query;
    const utms: UtmParams = {};
    for (const key in query) {
      if (key.startsWith('utm_') && typeof query[key] === 'string') {
        const decodedQuery = decodeURIComponent(query[key]);
        utms[snakeToCamelCase(key)] = decodedQuery;
      }
    }
    setUtmParams(utms);
  }, [router.isReady, router.query]);
  return utmParams;
}